// extracted by mini-css-extract-plugin
export default {"loadingIcon":"LoadingCard_loadingIcon__isoRP","shimmer":"LoadingCard_shimmer__lG4Ik","loadingName":"LoadingCard_loadingName__pymKw","fullView":"LoadingCard_fullView__Pf4kR"};